import React, { useState, useEffect } from 'react'
import api from '../../components/api'

import { useEnergiaRefrigeracaoContext } from '../../context/energiaRefrigeracaoUnitContext'
import { useEnergiaRefrigeracaoCamaraContext } from '../../context/energiaRefrigeracaoCamContext'

import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import Table from 'react-bootstrap/Table'


import { Link } from 'react-router-dom'
import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'


import StatusValidacaoSecao from '../StatusValidacaoSecao'

const Refrigeracao = (props) => {


    var ano = props.ano
    var energia_id = props.energia_id

    const { atualizacaoGestao } = useTabelaGestao()


    const { energiaRefrigeracao_id, setEnergiaRefrigeracao_id } = useEnergiaRefrigeracaoContext()

    const [resultadoRefrigeracao, setResultadoRefrigeracao] = useState()
    const [resultadoRefrigeracaoCamaraFria, setResultadoRefrigeracaoCamaraFria] = useState()

    const { energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id } = useEnergiaRefrigeracaoCamaraContext()


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    
    const [informa, setInforma] = useState(true)

    const [totalPendencias, setTotalPendencias] = useState(0)


    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        setQuestao2()
        
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Refrigeração - Equipamento Unitário':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break

                            case 'Refrigeração - Câmara Fria':

                                totalErros = totalErros + 1
                                setQuestao2('red')
    
                            break

                            
                        }

                    }

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    function consultaRefrigeracao() {


        api.get(`energiaRefrigeracaoListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)
            setResultadoRefrigeracao(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalRefrigeracaoUnitario').modal('show');setEnergiaRefrigeracao_id(rs.energiaRefrigeracao_id)}}>
                    <td>
                        {rs.tipo}
                    </td>
                    <td>
                        {rs.marca}
                    </td>
                    <td style={{ textAlign: 'right'}}>
                        {rs.quantidade}
                    </td>
                    <td>
                        {rs.identificacao}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function consultaRefrigeracaoCamara() {

        api.get(`energiaRefrigeracaoCamaraListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)

            setResultadoRefrigeracaoCamaraFria(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalRefrigeracaoCamara').modal('show');setEnergiaRefrigeracaoCamara_id(rs.energiaRefrigeracaoCamara_id)}}>
                    <td>
                        {rs.aplicacao}
                    </td>
                    <td>
                        {rs.marcaCamara}
                    </td>
                    <td style={{ textAlign: 'center'}}>
                        {rs.entradaOperacaoCamara}
                    </td>
                    <td style={{ textAlign: 'center'}}>
                        {rs.saidaOperacaoCamara}
                    </td>
                </tr>
            
            ))
            

        }).catch((err) => {

            console.log(err.response)

        })


    }



    useEffect(() => {

        var dataPost = {

            tipo: 'informaRefrigeracao',
            informa: informa,

        }

        api.post(`energiaInforma/${energia_id}`, dataPost).then((result) => {

            console.log(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }, [informa])



    const consultaInforma = () => {

        api.get(`energiaInforma/${energia_id}/informaRefrigeracao`).then((result) => {

            //console.log(result.data)
            setInforma(result.data[0].informaRefrigeracao)

        }).catch((err) => {

            console.log(err.response)

        })
    }




    useEffect(() => {

        consultaRefrigeracao()
        consultaRefrigeracaoCamara()
        consultaInforma()
        
    }, [ano, energia_id, atualizacaoGestao])




    return (
        <div>


            <div className="col-md-12">
                <div align="left">

                
                    <select className="form-control" value={informa}  onChange={event => setInforma(event.target.value)}>
                        <option value={true}>A instituição possui o(s) equipamento(s) e reportará suas informações</option>
                        <option value={false}>A instituição não possui o(s) equipamento(s) ou a instituição possui o(s) equipamento(s) mas não reportará suas informações</option>
                    </select>
                    <br/>

                </div>
            </div>

            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                
                    
                    <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('Refrigeração - Equipamento Unitário');setSecaoEnunciado('Refrigeração');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade para Equipamento Unitário]</Link>
                    <br/><br/>
                    
                    
                    <button type="button" className="btn btn-primary" onClick={() => {window.$('#modalRefrigeracaoUnitario').modal('show');setEnergiaRefrigeracao_id()}}  >+ Adicionar Equipamento Unitário</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec', textAlign: 'center'}}>

                                Quantidade

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Ambiente

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoRefrigeracao}
                    </tbody>

                </Table>

            </div>




            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                <br/><br/>

                    <Link to='#' style={{ color: questao2 }} onClick={() => {setEnunciado('Refrigeração - Câmara Fria');setSecaoEnunciado('Refrigeração');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade para Câmara Fria]</Link>
                    <br/><br/>
                    
                    <button type="button" className="btn btn-warning" onClick={() => {window.$('#modalRefrigeracaoCamara').modal('show');setEnergiaRefrigeracaoCamara_id()}}  >+ Adicionar Câmara Fria</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec', textAlign: 'center'}}>

                                Entrada operação

                            </th>
                            <th style={{backgroundColor: '#e6f7ec', textAlign: 'center'}}>

                                Saída operação

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoRefrigeracaoCamaraFria}
                    </tbody>

                </Table>

            </div>



            
            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoRefrigeracao" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Refrigeração" ano={ano} />



        </div>
    )


}

export default Refrigeracao